import { render, staticRenderFns } from "./TerminalEnvironmentSummary.vue?vue&type=template&id=2c9c0824&scoped=true"
import script from "./TerminalEnvironmentSummary.vue?vue&type=script&lang=js"
export * from "./TerminalEnvironmentSummary.vue?vue&type=script&lang=js"
import style0 from "./TerminalEnvironmentSummary.vue?vue&type=style&index=0&id=2c9c0824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9c0824",
  null
  
)

export default component.exports